import { createSlice } from "@reduxjs/toolkit";

interface Table {
  selectedRowNum: number | undefined;
}

const initialState: Table = {
  selectedRowNum: undefined,
};

export const TableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    getTableSelectedRow: (state: any, action: any) => {
      const { selectedRowNum } = action.payload;
      state.selectedRowNum = selectedRowNum;
    },
    getTablePage: (state: any, action: any) => {
      const { selectedPageNum } = action.payload;
      state.selectedPageNum = selectedPageNum;
    },
  },
});

export const { getTableSelectedRow, getTablePage } = TableSlice.actions;

export default TableSlice.reducer;
